// React
import React, { useState, useEffect, useContext } from "react";
// React
// CSS
import styles from "./QuizCreator.module.css";
// CSS
// Utils
import HelperHeader from "../../../Utils/HelperHeader/HelperHeader";
import SelectOptionBuilder from "../../../Utils/SelectOptionBuilder/SelectOptionBuilder";
// Utils
// Models
import { I_QuizOption, I_UserLesson } from "../../../Models/interfaces";
import { getLessons_Service } from "../../../Services/Common/getLessons_Service";
import { UserTokenContext } from "../../../Contexts/userToken";
import { getSubjectOfUserLesson_Service } from "../../../Services/Lessons/get/getSubjectOfUserLesson_Service";
import { makeQuiz_Service } from "../../../Services/Quiz/post/makeQuiz_Service";
import { SetUserQuestionContext } from "../../../Contexts/SetUserQuestionContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { SetLessonDataContext } from "../../../Contexts/SetLessonDataContext";
import Spinner from "../../../Utils/Spinner/Spinner";
import { toast } from "react-toastify";
// Models

const QuizCreator: React.FunctionComponent = () => {
  // States
  const [lessons, setLessons] = useState<I_UserLesson[]>([]);
  //
  const [lessonSubjects, setLessonSubjects] = useState<I_UserLesson[]>([]);
  //
  const [lessonData, setLessonData] = useState<{
    lessonName: string;
    subjectName: string;
  }>({
    lessonName: "",
    subjectName: "تصادفی",
  });
  //
  const [quizOptions, setQuizOptions] = useState<I_QuizOption>({
    lessonId: 0,
    questionCount: 0,
    subjectId: 0,
  });
  //
  const [isPending, setIsPending] = useState<boolean>(false);
  // States
  // constants
  const navigate = useNavigate();
  // constants
  // contexts
  const userToken = useContext(UserTokenContext);
  //
  const _setLessonData = useContext(SetLessonDataContext);
  //
  const setUserQuestions = useContext(SetUserQuestionContext);
  // contexts
  // LifeCycles
  //
  useEffect(() => {
    getLessons_Service(userToken).then(({ data: { data } }) => {
      setLessons(data);
    });
  }, [userToken]);
  //
  useEffect(() => {
    if (quizOptions.lessonId === 0) return;
    setLessonSubjects([]);
    setQuizOptions((prevState) => ({ ...prevState, subjectId: 0 }));
    getSubjectOfUserLesson_Service(userToken, String(quizOptions.lessonId))
      .then(({ data: { data } }) => {
        setLessonSubjects(data);
      })
      .catch((err) => {
        console.log(err);
        toast(
          err.response.data.message ? err.response.data.message : err.message
        );
      });
  }, [userToken, quizOptions.lessonId]);
  //
  // LifeCycles

  return (
    <div className={`${styles.quizCreator} mx-8 p-4 bg-white dark:!text-black`}>
      <HelperHeader absoluteText="تکمیل اطلاعات درخواستی" isBgWhite={true} />

      <input
        type="number"
        className="w-full mt-8 py-2 rounded-xl"
        placeholder="تعداد سوالات به لاتین"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setQuizOptions((prevState) => ({
            ...prevState,
            questionCount: Number(e.target.valueAsNumber),
          }));
        }}
      />

      <SelectOptionBuilder
        dataForBuildOptions={lessons}
        initialShowName="انتخاب درس"
        onClick={(data) => {
          setQuizOptions((prevState) => ({
            ...prevState,
            lessonId: Number(data),
          }));
          console.log(data);
          setLessonData((prevState) => ({
            ...prevState,
            lessonName:
              lessons.find((item) => String(item.id) === data)?.title ?? " ",
          }));
          if (!_setLessonData) return;
          _setLessonData((prevState) => ({
            ...prevState,
            lessonId: data,
            lessonName: String(
              lessons.find((item) => String(item.id) === data)?.title
            ),
          }));
        }}
        className={styles.selectOptionContainer}
      />

      <SelectOptionBuilder
        dataForBuildOptions={lessonSubjects}
        initialShowName="انتخاب فصل"
        onClick={(data) => {
          setQuizOptions((prevState) => ({
            ...prevState,
            subjectId: Number(data),
          }));
          console.log(data);
          setLessonData((prevState) => ({
            ...prevState,
            subjectName:
              Number(data) === 0
                ? "اتخاب تصادفی"
                : lessonSubjects.find((item) => String(item.id) === data)
                    ?.title ?? "",
          }));
          if (!_setLessonData) return;
          _setLessonData((prevState) => ({ ...prevState, subjectId: data }));
        }}
        className={styles.selectOptionContainer}
        onOpen={() => {
          if (quizOptions.lessonId !== 0) {
            return true;
          }
          toast("ابتدا درس را انتخاب کنید");
          return false;
        }}
      />

      <button
        className={`${styles.quizCreatorBtn} w-full py-2 mt-4 text-white rounded-lg flex justify-center items-center`}
        onClick={() => {
          if (isPending) return;
          if (
            quizOptions.questionCount === 0 ||
            quizOptions.lessonId === 0 ||
            quizOptions.subjectId === 0
          ) {
            if (quizOptions.questionCount === 0) {
              toast("تعداد سوالات را مشخص کنید");
              return;
            }
            if (quizOptions.lessonId === 0) {
              toast("درس را انتخاب کنید");
              return;
            }
            if (quizOptions.subjectId === 0) {
              toast("فصل را انتخاب کنید");
              return;
            }
            return;
          }
          //
          else {
            setIsPending(true);
            toast("در حال آماده سازی سوالات");
            makeQuiz_Service(
              userToken,
              quizOptions.lessonId,
              Math.abs(quizOptions.questionCount),
              quizOptions.subjectId
            )
              .then(({ data: { data }, status }) => {
                setIsPending(false);
                if (setUserQuestions !== null) {
                  if (status === 200 || 201) {
                    setUserQuestions(data);
                  }
                  return;
                }
              })
              .then(() => {
                toast("به صفحه ی آزمون منتقل می شوید ");
                navigate("/quiz-maker/quiz-questions", {
                  state: {
                    lessonData: `${lessonData.lessonName} ${lessonData.subjectName}`,
                    currMode: "creator",
                  },
                });
              })
              .catch((err) => {
                console.log(err);
                setIsPending(false);
                Swal.fire({
                  icon: "error",
                  title: err.response.data.message
                    ? err.response.data.message
                    : err.message,
                });
              });
          }
        }}
      >
        {isPending ? (
          <>
            <Spinner />
          </>
        ) : (
          <>ســاخت آزمــون</>
        )}
      </button>
    </div>
  );
};

export default QuizCreator;
